import { useState } from "react";
// Common Components
import { CheckBox } from "src/Components";
// Hooks
import useSearchParam from "src/Hooks/useSearchParam";
// Local Components
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import SearchParamUI from "./SearchParamUI";
import { Additional } from "./Additional";
// Requests
import { getGoldPositionWatchListTable } from "src/Requests/goldArbitrage";
// Types
import {
  GoldPositionWatchListSearchParams,
  GoldPositionWatchListTableReport,
} from "src/Interfaces/goldArbitrage";
import { ITableUI } from "src/Tables/TableTemplate/tableTemplate";

const WatchList = () => {
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({
    initialSearchParam: {} as GoldPositionWatchListSearchParams,
  });

  return (
    <div className="flex flex-row justify-start items-start gap-1 w-full">
      <SearchParamUI
        searchParam={clientSearchParams}
        searchParamChangeHandler={clientSearchParamChangeHandler}
        onSubmit={onSubmit}
      />
      <div className="flex flex-col justify-start items-start gap-3 w-[calc(100%-220px)]">
        <div className="flex flex-row justify-start items-end gap-5 w-full">
          <TableTemplate<
            GoldPositionWatchListSearchParams,
            GoldPositionWatchListTableReport
          >
            TableUI={({
              reports,
              onAction,
              sortingType,
              setSortingType,
              scrollKey,
            }: ITableUI<GoldPositionWatchListTableReport>) => (
              <CommonTableUI
                reports={reports}
                onAction={onAction}
                tableBoxClassName="!max-h-[600px] !max-w-full"
                sortingType={sortingType}
                setSortingType={setSortingType}
                scrollKey={scrollKey}
                AdditionalBody={Additional}
              />
            )}
            refreshTableTime={5000}
            getDataTable={getGoldPositionWatchListTable}
            searchParameters={serverSearchParams}
            withSort
          />
        </div>
      </div>
    </div>
  );
};

export default WatchList;
